<template>
  <div>
    <form>
      <br />
      <md-card>
        <md-card-header>
          <div class="md-title">Editar modelo padrão do local</div>
        </md-card-header>

        <md-card-content>
          <div>
            <p class="md-error" style="color: #ff1744">
              * Esse modelo é o padrão para executar a calibração!
            </p>
            <md-field>
              <label>Modelo Inp padrão</label>
              <md-textarea
                v-model="epanetEdit.modeloInp"
                style="height: 50vh"
              />
            </md-field>
          </div>

          <div style="text-align: right">
            <md-button
              class="md-primary md-raised"
              @click="() => $router.back()"
            >
              Voltar
            </md-button>
            <md-button class="md-primary md-raised" @click="saveEpanetEdit">
              Salvar
            </md-button>
          </div>
        </md-card-content>
      </md-card>
    </form>
  </div>
</template>

<script>
import http from '../../utils/http'

export default {
  name: 'EpanetAdmin',
  data() {
    return {
      localId: null,
      epanetEdit: {
        id: null,
        create: true,
        modeloInp: '',
      },
    }
  },
  async beforeMount() {
    this.localId = this.$route.params.localId

    await this.buscarModelo(this.localId)
  },
  methods: {
    async buscarModelo(localId) {
      const response = await http.get('epanet/local/' + localId)

      if (response === undefined) {
        return
      }

      this.epanetEdit.id = response.id
      this.epanetEdit.create = false
      this.epanetEdit.modeloInp = response.modeloInp
    },
    async saveEpanetEdit() {
      let id

      if (this.epanetEdit.create) {
        id = await http.post('epanet', {
          localId: this.localId,
          modeloInp: this.epanetEdit.modeloInp,
        })
      } else {
        id = await http.put('epanet', {
          id: this.epanetEdit.id,
          modeloInp: this.epanetEdit.modeloInp,
        })
      }

      this.epanetEdit.id = id
      this.epanetEdit.create = false
    },
  },
}
</script>
